@if (mission) {
  <div class="options">
    <div>
      <button class="icon"><img src="assets/images/back-icon.svg" (click)="backToMissionConfig()"/></button>
    </div>
    <div>
      <button class="icon"><img [src]="getSupportStatusIcon()" (click)="toggleSupportStatus()"/></button>
    </div>
    <div>
      @if (!isSupportComplete()) {
        <button class="icon"><img src="assets/images/add-button.svg" (click)="openTeamModal()"/></button>
      }
    </div>
  </div>
}

<table>
  <tr class="header">
    <th>{{ 'TEAM.TEAM_MEMBER' | translate }}</th>
    <th>{{ 'TEAM.LOCATION' | translate }}</th>
    <th>{{ 'TEAM.LAST_UPDATE' | translate }}</th>
    <th></th>
  </tr>

  @for (team of missionSupportTeams; track team) {
    <tr>
      <td>{{ team.teamMemberFirstName }} {{ team.teamMemberName }}</td>
      <td>{{ team.peoplelocationname }}</td>
      <td>{{ team.lastUpdatedOn | timestampToDate | async }} {{ team.lastUpdatedBy }}</td>
      <td>
        @if (!isSupportComplete()) {
          <img src="assets/images/trash-icon.svg" (click)="removeTeam(team)"/>
        }
      </td>
    </tr>
  }
</table>

<div class="footer">
  @for (team of runIteamTeams; track team) {
    <div class="row">
      <div>{{ team.teamMemberFirstName }} {{ team.teamMemberName }}</div>
      <div>{{ team.peoplelocationname }}</div>
      <div></div>
      <div></div>
    </div>
  }
</div>

@if (addingTeam) {
  <app-add-team
    [missionTeams]="missionSupportTeams"
    [rolename]="rolename"
    [defaultMarket]="mission.marketname"
    (closeModal)="closeTeamModal($event)"
    (addTeam)="addTeam($event)">
  </app-add-team>
}